var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "nonzero",
    d: "M12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 Z M12,2.57142857 C6.79274379,2.57142857 2.57142857,6.79274379 2.57142857,12 C2.57142857,17.2072562 6.79274379,21.4285714 12,21.4285714 C17.2072562,21.4285714 21.4285714,17.2072562 21.4285714,12 C21.4285714,6.79274379 17.2072562,2.57142857 12,2.57142857 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 11 12)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "loading-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.57142857,11 L1.57142857,11.1294218 C1.57142857,11.9258201 0.92582015,12.5714286 0.129421802,12.5714286 C0.129421802,12.5714286 0.129421802,12.5714286 0.129421802,12.5714286 C0.0608199601,12.350713 0.0176793596,11.8269035 0,11 C0,4.92486775 4.92486775,0 11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C10.3083042,22 9.78449466,21.958653 9.42857143,21.8759589 C9.42857143,21.8759589 9.42857143,21.8759589 9.42857143,21.8759589 C9.42857143,21.0765889 10.0765889,20.4285714 10.8759589,20.4285714 L11,20.4285714 L11,20.4285714 C16.2072562,20.4285714 20.4285714,16.2072562 20.4285714,11 C20.4285714,5.79274379 16.2072562,1.57142857 11,1.57142857 C5.79274379,1.57142857 1.57142857,5.79274379 1.57142857,11 Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1890FF",
    mask: "url(#loading-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(1 0 0 -1 -1 23)"
  }))), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "1s",
    from: "0 12 12",
    to: "360 12 12",
    repeatCount: "indefinite"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.23797fce.svg";
export { ForwardRef as ReactComponent };